import React from 'react'
import { withRouter } from 'react-router'
import SearchUI from '../../../widgets/input/SearchUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import './VendorList.css'

const CustomerListUI = ({ context, messageList, customerList,
  // filters
  searchFilter, onSearchFilterChange,
  // modes
  selectedCount,
  // event handlers
  onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick, onRowClick }) =>
  <div className='c_vndrs'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          selectedCount={selectedCount}
          onRefreshClick={onRefreshClick}
          onCreateClick={onCreateClick}
          onUpdateClick={onUpdateClick}
          onDeleteClick={onDeleteClick}
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    <LRTableBodyUI>
      {
        customerList.map((customer, i) =>
          <CustomerRowUI key={i} context={context} customer={customer}
            messageList={messageList} onRowClick={onRowClick}
          />
        )
      }
    </LRTableBodyUI>
  </div>

const ActionLeftUI = ({ context, messageList, selectedCount, onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick }) =>
  <React.Fragment>
    {
      selectedCount === 0 &&
      <div className='g_flex_h'>
        <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
        {/*
          context.permissions.includes('acc_manage') &&
          <IconButtonUI messageList={messageList} icon='icon-plus' onClick={onCreateClick} labelKey='c_create_vendor' />
        */}
      </div>
    }
    {
      selectedCount > 0 &&
      <div className='action g_flex_h'>
        {
          selectedCount === 1 &&
          <IconButtonUI messageList={messageList} icon='icon-pencil' onClick={onUpdateClick} label='Update Customer' />
        }
        <IconButtonUI messageList={messageList} icon='icon-trash-o' onClick={onDeleteClick} label='Delete Customer' />
      </div>
    }
  </React.Fragment>

const ActionTopRightUI = ({ context, messageList, searchFilter, onSearchFilterChange }) =>
  <div className='g_flex_h'>
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

const CustomerRowUI = ({ context, messageList, customer, onRowClick }) =>
  <LRTableRowUI
    context={context} className='g_flex_top'
    left={<RowLeftUI context={context} customer={customer} onRowClick={onRowClick} />}
    right={<RowRightUI customer={customer} messageList={messageList} />}
    rowId={customer.customerId}
  />

const RowLeftUI = ({ context, customer, onRowClick }) =>
  <div className='g_flex_h g_flex_top'>
    <div>
      <span>
        {customer.customerName}
        {
          customer.addressList && customer.addressList.length &&
          <>, {customer.addressList[0].state}</>
        }
      </span>
      <div className='g_muted g_flex_v'>
        <span>
          {customer.contactFirstName} {customer.contactLastName}
        </span>
        <span>{customer.contactPhone}</span>
        <span>{customer.contactEmail}</span>
      </div>
    </div>
  </div>

const RowRightUI = ({ customer, messageList }) =>
  <div className='right g_flex_v'>
  </div>

export default withRouter(CustomerListUI)
